import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformService {
  private readonly platformId = inject(PLATFORM_ID);

  readonly isMobile = signal(this.detectMobile());

  private detectMobile(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    return window.matchMedia('(pointer: coarse)').matches;
  }
}
